const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the content liked by component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Users} Users the resource defined to manage Users
 * @argument {Categories} Categories the resource defined to manage Categories
 */
app.directive('usersSearch', ['Application', 'AdminUsers', 'Users', 'AccessHelper', 'Categories', 'Skills', '$q', '$translate', function (Application, AdminUsers, Users, AccessHelper, Categories, Skills, $q, $translate) {
  return {
    restrict: 'E',
    scope: {
      onQuery: '&',
      clear: '=',
      placeholder: '=',
      userRestrictions: '=',
      optionRestrictions: '=',
      explore: '@',
      suspended: '@',
      filterType: '@?',
      usersHide: '=?',
      hideLevel: '=?',
      hideGrade: '=?',
      reports: '=?',
      prioritizeCreator: '@?',
      allowUser: '@?'
    },
    template: require('../../templates/directives/users-searchbar.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      // Available query types: department|location|role|text|hired|created|active
      var restrictedGroup = Application.access.profile && Application.access.profile.permissions && Application.access.profile.permissions.admin && Application.access.profile.permissions.admin.users && Application.access.profile.permissions.admin.users.user_group || {};
      self.allowance = {
        view: AccessHelper.isAllowed(['admin', 'users', 'view'], null, ['admin', 'creator', 'manager']),
        view_restricted: AccessHelper.isAllowed(['admin', 'users', 'restricted_access'], null, ['admin', 'creator', 'manager'])
      };

      // if (!self.allowance.view && !$scope.reports) {
      //   Application.navigation.goTo('/explore');
      //   return;
      // }

      self.restricted = false;
      if (self.allowance.view_restricted) {
        self.restricted = true;
      }

      self.translations = {};
      self.queryIds = {};
      self.queries = [];
      self.departments = {};
      self.locations = {};
      self.teams = {};
      self.org_levels = {};
      self.grades = {};
      self.activeFilter = '';
      self.filtersVisible = false;
      self.allowFilters = $scope.filterType && $scope.filterType === 'none' ? false : true;
      self.suspendedHide = $scope.suspended ? {'display': 'none'} : '';
      self.roleOptions = [
        {
          type: 'role',
          name: 'Admins',
          text: 'Admins',
          value: 'admin',
          _id: 'admin-role'
        }, {
          type: 'role',
          name: 'Creators',
          text: 'Creators',
          value: 'creator',
          _id: 'creator-role'
        }, {
          type: 'role',
          name: 'Users',
          text: 'Users',
          value: 'user',
          _id: 'user-role'
        },
        {
          type: 'role',
          name: 'External Users',
          text: 'External Users',
          value: 'external',
          _id: 'external-role'
        }
      ].filter(function (role_option) {
        if(!$scope.userRestrictions) {
          return role_option;
        }
        if(!$scope.userRestrictions.role) {
          return role_option;
        }
        return role_option.value === $scope.userRestrictions.role;
      });
      self.placeholder = $scope.placeholder;
      if (self.placeholder === undefined) {
        self.placeholder = 'modules.usersearch.placeholder';
      }

      var getLineage = function(id, type) {
        var items = [id];
        var children = [];
        var grandChildren = [];

        var addTo = function(id) {
          children.push(id);
          var main = self[type][id];
          if (!main || !main.children || !main.children.length) {
            return;
          }
          for (var i = 0; i < main.children.length; i++) {
            grandChildren.push(main.children[i]);
          }
        };

        if (!self[type][id] || !self[type][id].children || !self[type][id].children.length) {
          return items;
        }

        for (var i = 0; i < self[type][id].children.length; i++) {
          addTo(self[type][id].children[i], children);
        }

        return items.concat(children, grandChildren);
      };

      var dateAgo = function(days) {
        return 'date-' + moment().subtract(days, 'days').format('MM-DD-YY');
      };

      var textQuery = function(text) {
        return '15,full_name,$regex,2,' + text.replace(',', '.*') + ',i,job_title,$regex,2,' + text.replace(',', '.*') + ',i,email,$regex,2,' + text.replace(',', '.*') + ',i';
      };

      self.updateQuery = function() {
        var skills = [];
        var item = {};

        for (var i = 0; i < self.queries.length; i++) {
          switch (self.queries[i].type) {
            case 'location':
              var locations = getLineage(self.queries[i]._id, 'locations');
              item.linked_locations = '$in,' + locations.length + ',' + locations.join(',');
              break;
            case 'department':
              var departments = getLineage(self.queries[i]._id, 'departments');
              item.linked_departments = '$in,' + departments.length + ',' + departments.join(',');
              break;
            case 'team':
              var teams = getLineage(self.queries[i]._id, 'teams');
              item.linked_teams = '$in,' + teams.length + ',' + teams.join(',');
              break;
            case 'org_level':
              var org_levels = getLineage(self.queries[i]._id, 'org_levels');
              item.linked_org_level = '$in,' + org_levels.length + ',' + org_levels.join(',');
              break;
            case 'grade':
              var grades = getLineage(self.queries[i]._id, 'grades');
              item.linked_grade = '$in,' + grades.length + ',' + grades.join(',');
              break;
            case 'user':
              item._id = self.queries[i]._id;
              break;
            case 'role':
              item.role = self.queries[i].value;
              break;
            case 'skill':
              skills.push(self.queries[i]._id);
              break;
            case 'hired':
              item.hired = '$gte,' + dateAgo(self.queries[i].text);
              break;
            case 'created':
              item.createdAt = '$gte,' + dateAgo(self.queries[i].text);
              break;
            case 'active':
              item.last_login = '$gte,' + dateAgo(self.queries[i].text);
              break;
            case 'text':
              item['$or'] = textQuery(self.queries[i].name);
              break;
            default:
              break;
          }
        }
        if (skills.length === 1) {
          item.skills = skills[0];
        }
        if (skills.length > 1) {
          item.skills = '$all,' + skills.length + ',' + skills.join(',');
        }
        $scope.onQuery({query: item});
      };

      self.makeLabel = function(type, value) {
        if (type === 'department' || type === 'location' || type === 'team' || type === 'org_level' || type === 'grade' || type === 'text' || type === 'role') {
          return value;
        }
        if (type === 'hired') {
          return self.translations['edit.assessment.hired_within'] + ' ' + value + ' ' + self.translations['edit.assessment.days'];
        }
        if (type === 'created') {
          return self.translations['edit.assessment.created_less'] + ' ' + value + ' ' + self.translations['edit.assessment.days_ago'];
        }
        if (type === 'active') {
          if (value === 1) {
            return self.translations['edit.assessment.active_today'];
          }
          return self.translations['edit.assessment.active_within'] + ' ' + value + ' ' + self.translations['edit.assessment.days_ago'];
        }
      };

      self.removeUnique = function(type) {
        if (type === 'skill') {
          return;
        }
        for (var i = 0; i < self.queries.length; i++) {
          if (self.queries[i].type === type) {
            var removed = self.queries.splice(i, 1);
            self.queryIds[removed[0]._id] = false;
            return;
          }
        }
      };

      self.outsideAdd = function(type, value) {
        self.removeUnique(type);
        var item;
        if (type === 'role') {
          item = value;
        } else {
          item = {
            name: self.makeLabel(type, value),
            text: value,
            _id: value + type,
            type: type
          };
        }
        self.queries.push(item);
        self.addedTag(item, true);
      };


      // ------------- start ngTag triggered actions ------------
      self.addingTag = function($tag) {
        if ($tag.type && $tag.type !== 'user') {
          self.removeUnique($tag.type);
          return true;
        }
        if (Object.keys($tag).length === 1 && $tag.name) {
          $tag.text = $tag.name;
          $tag._id = $tag.name + '-text';
          $tag.type = 'text';
          self.removeUnique($tag.type);
          return true;
        }
        if ($tag.type && $tag.type === 'user') {
          self.queryIds = {};
          self.queries.splice(0);
          return true;
        }
      };

      self.addedTag = function($tag, outside) {
        if (!outside) {
          self.queryIds[$tag._id] = true;
        }
        self.updateQuery();
      };

      self.removedTag = function($tag) {
        self.queryIds[$tag._id] = false;
        self.updateQuery();
      };

      self.removeTags = function() {
         self.queries = [];
         self.updateQuery();
      };
      // ------------- End ngTag triggered actions ------------


      var legacyName = function(item, type) {
        var name = '';
        var parent;
        var parentName;
        var papa;
        var papaName;

        item.legacyName = item.name;
        item.lineage = [item._id];

        if (item.parent) {
          parent = self[type][item.parent];
          parentName = parent.name + ' -> ';
          papa = parent.parent;
          item.legacyName = parentName + item.name;
          item.lineage.push(parent._id);
        }

        if (papa) {
          papa = self[type][papa];
          papaName = papa.name + ' -> ';
          item.legacyName = papaName + parentName + item.name;
          item.lineage.push(papa._id);
        }
      };

      self.sortCategories = function(data) {
        angular.forEach(data, function(cat) {
          if (cat.location) {
            self.locations[cat._id] = cat;
          }
          if (cat.department) {
            self.departments[cat._id] = cat;
          }
          if (cat.team) {
            self.teams[cat._id] = cat;
          }
          if (cat.org_level && !($scope.hideLevel && $scope.hideLevel === true)) {
            self.org_levels[cat._id] = cat;
          }
          if (cat.grade && !($scope.hideGrade && $scope.hideGrade === true)) {
            self.grades[cat._id] = cat;
          }
        });
        for (var loc in self.locations) {
          legacyName(self.locations[loc], 'locations');
        }
        for (var dep in self.departments) {
          legacyName(self.departments[dep], 'departments');
        }
        for (var team in self.teams) {
          legacyName(self.teams[team], 'teams');
        }
        for (var level in self.org_levels) {
          legacyName(self.org_levels[level], 'org_levels');
        }
        for (var grade in self.grades) {
          legacyName(self.grades[grade], 'grades');
        }
      };

      var placeholders = {
        users: {name: 'Users', text: 'Users', _id: 'users', placeholder: true},
        skills: {name: 'Skills', text: 'Skills', _id: 'skills', placeholder: true},
        locations: {name: 'Locations', text: 'Locations', _id: 'locations', placeholder: true},
        departments: {name: 'Departments', text: 'Departments', _id: 'departments', placeholder: true},
        teams: {name: 'Teams', text: 'Teams', _id: 'teams', placeholder: true},
        org_levels: {name: 'OrgLevels', text: 'OrgLevels', _id: 'org_levels', placeholder: true},
        grades: {name: 'Grades', text: 'Grades', _id: 'grades', placeholder: true},
        categories: {name: 'Categories', text: 'Categories', _id: 'categories', placeholder: true}
      };

      self.getOptions = function(input) {
        var deferred = $q.defer();

        input = input ? input.toLowerCase().replace(',', '.*') : '';

        var addedItems = {
          users: false,
          locations: false,
          departments: false,
          teans: false,
          org_levels: false,
          grades: false,
          skills: false
        };

        var query = {
          page: 1,
          per_page: 6,
          full_name: '$regex,2,' + input + ',i',
          sort: 'full_name,-1'
        };

        if ($scope.suspended) {
          query.suspended = true;
        }

        if ($scope.userRestrictions) {
          for (var key in $scope.userRestrictions) {
            query[key] = $scope.userRestrictions[key];
          }
        }

        if ($scope.prioritizeCreator) {
          query.prioritize_creator = true;
        }

        if ($scope.allowUser) {
          query.fields = 'first_name,last_name,email,full_name,role,image,last_login,manager_email,skills,groups,managing_groups';
        }

        var usersPromise = $scope.allowUser ? Users.find(query).$promise : AdminUsers.find(query).$promise;
        var skillsPromise = Skills.find({blocked: '$ne,true', name: '$regex,2,' + input + ',i'}).$promise;

        $q.all([usersPromise, skillsPromise])
        .then(function(results) {
          var users = results[0];
          var skills = results[1];
          var items = [];

          // Add users to options
          for (var i = 0; i < users.length; i++) {
            if ($scope.optionRestrictions && $scope.optionRestrictions.users) {
              break;
            }
            if ($scope.usersHide && $scope.usersHide.indexOf(users[i]._id) !== -1) {
              break;
            }
            if (!self.queryIds[users[i]._id]) {
              if (!addedItems.users) {
                items.push(placeholders.users);
                addedItems.users = true;
              }

              items.push({
                name: users[i].full_name,
                first_name: users[i].first_name,
                last_name: users[i].last_name,
                text: users[i].full_name,
                image: users[i].image,
                _id: users[i]._id,
                type: 'user'
              });
            }
          }

          var types = ['locations', 'departments', 'teams', 'org_levels', 'grades'];

          types.forEach(function(type) {
            if (!self[type]) {
              return;
            }

            for (var item in self[type]) {
              if ($scope.optionRestrictions && $scope.optionRestrictions[type]) {
                break;
              }

              if (new RegExp(input).test(self[type][item].name.toLowerCase()) && !self.queryIds[self[type][item]._id]) {

                // Test matching segmentation lineage for restriction allotment
                if (self.restricted && restrictedGroup[type] && restrictedGroup[type].length) {
                  var allow = false;
                  var itemLineage = self[type][item].lineage || [];
                  for (var i = 0; i < itemLineage.length; i++) {
                    if (restrictedGroup[type].indexOf(itemLineage[i]) !== -1) {
                      allow = true;
                      break;
                    }
                  }
                  if (!allow) {
                    continue;
                  }
                }

                if (!addedItems[type]) {
                  items.push(placeholders[type]);
                  addedItems[type] = true;
                }

                items.push({
                  name: self[type][item].name,
                  text: self[type][item].legacyName,
                  _id: self[type][item]._id,
                  type: type.slice(0, -1)
                });
              }
            }
          });

          // Add skills to options
          for (var j = 0; j < skills.length; j++) {
            if ($scope.optionRestrictions && $scope.optionRestrictions.skills) {
              break;
            }
            if (self.queryIds[skills[j]._id]) {
              continue;
            }
            if (!addedItems.skills) {
              items.push(placeholders.skills);
              addedItems.skills = true;
            }

            items.push({
              name: skills[j].name,
              text: skills[j].name,
              _id: skills[j]._id,
              type: 'skill'
            });
          }

          deferred.resolve(items);
        });

        return deferred.promise;
      };

      self.initialize = function() {
        Categories.find({
          fields: ['_id', 'name', 'localized_names', 'category', 'location', 'department', 'team', 'org_level', 'grade', 'company', 'level', 'parent', 'children'].join(','),
          $or: '10,location,true,department,true,team,true,org_level,true,grade,true',
          sort: 'name,1'
        }).$promise
        .then(function(data) {
          self.sortCategories(data);
        });
      };

      $translate([
        'edit.assessment.active_today',
        'global.contentTypes.users',
        'overview.settings.tabs_locations',
        'overview.settings.tabs_departments',
        'overview.settings.tabs_teams',
        'overview.settings.tabs_org_levels',
        'overview.settings.tabs_grades',
        'overview.settings.tabs_skills',
        'edit.assessment.hired_within',
        'edit.assessment.created_less',
        'edit.assessment.active_today',
        'edit.assessment.active_within',
        'edit.assessment.days',
        'edit.assessment.days_ago'
      ]).then(function(translations) {
        self.translations = translations;
        placeholders.users = {name: self.translations['global.contentTypes.users'], text: self.translations['global.contentTypes.users'], _id: 'users', placeholder: true};
        placeholders.locations = {name: self.translations['overview.settings.tabs_locations'], text: self.translations['overview.settings.tabs_locations'], _id: 'locations', placeholder: true};
        placeholders.settings = {name: self.translations['overview.settings.tabs_departments'], text: self.translations['overview.settings.tabs_departments'], _id: 'departments', placeholder: true};
        placeholders.teams = {name: self.translations['overview.settings.tabs_teams'], text: self.translations['overview.settings.tabs_teams'], _id: 'teams', placeholder: true};
        placeholders.org_levels = {name: self.translations['overview.settings.tabs_org_levels'], text: self.translations['overview.settings.tabs_org_levels'], _id: 'org_levels', placeholder: true};
        placeholders.grades = {name: self.translations['overview.settings.tabs_grades'], text: self.translations['overview.settings.tabs_grades'], _id: 'grades', placeholder: true};
        placeholders.skills = {name: self.translations['overview.settings.tabs_skills'], text: self.translations['overview.settings.tabs_skills'], _id: 'skill', placeholder: true};
      });

      self.initialize();

      $scope.$watch('clear', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          self.removeTags();
          $scope.clear = false;
        }
      });

      $scope.$watch('placeholder', function(newVal, oldVal) {
        if (newVal) {
          self.placeholder = newVal;
        }
      });
    }],
    controllerAs: 'search'
  };
}]);
